export default "/images/adab236c29bfe9afa9a20b7c012059de.avif";